export default "__VITE_ASSET__mmjYZu2N__"